import { FGEmpty, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ClasseHoraireApi } from "../../../../../../api";
import { SmallFormGenerator, FGWalterDateMaskInput } from "../../../../../../components";
import { useApiService, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import { useEventsContext } from "../../../../../../contexts";
import { CLASSE_HORAIRE_ACTIONS } from "..";

export interface IAjoutDatePageProps {
  idClasse: number;
}

export const AjoutDatePage: React.FunctionComponent<IAjoutDatePageProps> = ({ idClasse }) => {
  const { t } = useTl();
  const api = useApiService(ClasseHoraireApi);
  const { dispatchEvent } = useEventsContext();

  const [loading, setLoading] = React.useState(false);

  return (
    <>
      <SmallFormGenerator
        initialValues={{ idClasse: idClasse, day: new Date() }}
        onSubmit={async d => {
          setLoading(true);
          await api.classeHoraireAjoutDateHoraire({ idClasse: d.idClasse, dayToAdd: d.day });
          setLoading(false);
          dispatchEvent(CLASSE_HORAIRE_ACTIONS, true);
        }}
        editMode={true}
        saving={loading}
      >
        <FieldGroup columns={2}>
          <FGWalterDateMaskInput label={t(ETLCodes.DateAjouter)} name="day" showPlaceholder={false} />
          <FGEmpty />
        </FieldGroup>
      </SmallFormGenerator>
    </>
  );
};
